/**
 * Return true if the field value matches the given format RegExp
 *
 * @example $.validator.methods.pattern("AR1004",element,/^AR\d{4}$/)
 * @result true
 *
 * @example $.validator.methods.pattern("BR1004",element,/^AR\d{4}$/)
 * @result false
 *
 * @name $.validator.methods.pattern
 * @type Boolean
 * @cat Plugins/Validate/Methods
 */
$.validator.addMethod(
  "pattern",
  function (value, element, param) {
    if (this.optional(element)) {
      return true;
    }
    if (typeof param === "string") {
      param = new RegExp("^(?:" + param + ")$");
    }
    return param.test(value);
  },
  "Invalid format."
);
